export const menuData = [
  { 'fullPath': '/dashboard', config: 'dashboard' },
  { 'fullPath': '/sessions', config: 'sessions' },
  { 'fullPath': '/heatmaps', config: 'heatmaps' },
];
